import { useLocation } from '@remix-run/react';

import { getPathAndRepubFromUrlPath } from '~/utils/getPathAndRepubFromUrlPath';

import arrow from './icons/arrow.svg';
import home from './icons/home.svg';
import styles from './Breadcrumbs.module.css';

export const Breadcrumbs = (): JSX.Element => {
  const location = useLocation();

  const { path, repub } = getPathAndRepubFromUrlPath(location.pathname);
  const urlRepub = repub === 'OC' ? '' : `/${repub.toLowerCase()}`;
  const breadcrumbs = path.split('/').filter(Boolean);

  return (
    <nav
      aria-label="breadcrumbs"
      className={styles.breadcrumbsContainer}
      data-testid="breadcrumbs">

			<div className={styles.breadcrumbsWrapper}>
				<ol className={styles.breadcrumbsOl}>
					<li className={styles.breadCrumbLi}>
						<a href="./">
							<picture>
								<source srcSet={home} type="image/svg+xml" />
								<img alt="home" height={14} src={home} width={14} />
							</picture>
						</a>
					</li>
					{breadcrumbs.map((breadcrumb, idx) => {
            const href = `${urlRepub}/${breadcrumbs.slice(0, idx + 1).join('/')}`;
            const isLast = idx === breadcrumbs.length - 1;
            const formattedBreadcrumb = breadcrumb.replace(/-/g, ' ');

            const arrowElement =
            <span className={styles.arrowWrap}>
								<picture className={styles.arrow}>
									<source srcSet={arrow} type="image/svg+xml" />
									<img alt="arrow" height={14} src={arrow} width={8} />
								</picture>
							</span>;


            const textElement =
            <span className={styles.breadCrumbText}>
								{formattedBreadcrumb}
							</span>;


            const breadCrumbLink =
            <a
              className={styles.breadCrumbLink}
              href={href}
              title={formattedBreadcrumb}>

								{textElement}
							</a>;


            const lastBreadCrumb =
            <span className={styles.breadCrumbLast}>{textElement}</span>;


            return (
              <li className={styles.breadCrumbLi} key={href}>
								{arrowElement} {isLast ? lastBreadCrumb : breadCrumbLink}
							</li>);

          })}
				</ol>
			</div>
		</nav>);

};